export function sleep(ms: number): Promise<null> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms, null);
  });
}

export function throwWhenTimeout(ms: number, createTimeoutError: () => Error): Promise<never> {
  return new Promise((_, reject) => {
    setTimeout(() => reject(createTimeoutError()), ms);
  });
}

export interface RetryUntilTimeoutOrSuccessConfig<T> {
  tryFn: () => T | Promise<T>;
  timeoutErrorFn: () => Error;
  abortSignal: AbortSignal;
  interval: number;
  timeout: number;
}
export function retryUntilTimeoutOrSuccess<T>(config: RetryUntilTimeoutOrSuccessConfig<T>): Promise<NonNullable<T>> {
  const { tryFn, timeoutErrorFn, abortSignal, interval, timeout } = config;
  let fulfilled = false;
  return Promise.race([
    throwWhenTimeout(timeout, timeoutErrorFn),
    (async () => {
      while (!fulfilled) {
        if (abortSignal.aborted) throw abortSignal.reason;
        try {
          const result = await tryFn();
          if (result) return result;
        } catch {
          /* ignore errors */
        }
        await sleep(interval);
      }
      return undefined as never;
    })(),
  ]).finally(() => (fulfilled = true));
}
